import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RoleRequest } from '../models/requests/role-request';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { RoleDto } from '../models/RoleDto';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private httpClient: HttpClient) { }
  getRoles(): Observable<ApiResponseObject<RoleDto[]>> {
    return this.httpClient.get<ApiResponseObject<RoleDto[]>>(`${environment.apiUrl}/Roles`);
  }
  
  saveRole(roleRequest: RoleRequest): Observable<ApiResponseObject<RoleDto>> {
   
    return this.httpClient.post<ApiResponseObject<RoleDto>>(`${environment.apiUrl}/Roles`, roleRequest);
  }

  getRolesForUser(userid: string): Observable<ApiResponseObject<RoleDto[]>> {
    return this.httpClient.get<ApiResponseObject<RoleDto[]>>(`${environment.apiUrl}/Roles/user/${userid}`);
  }
}
